export const contractsConfig = {
    CALL: {
        euro_atm: {
            contract_category_display: "Rise/Fall",
            contract_display: "Rise"
        },
        euro_non_atm: {
            contract_category_display: "Higher/Lower",
            contract_display: "Higher"
        }
    },
    PUT: {
        euro_atm: {
            contract_category_display: "Rise/Fall",
            contract_display: "Fall"
        },
        euro_non_atm: {
            contract_category_display: "Higher/Lower",
            contract_display: "Lower"
        }
    }
}
